/**
 * Analytics helper functions for Lists component NULL STATE tracking only
 * Following the schema pattern from NullView.txt guide
 */

/**
 * Creates and fires a standard analytics event
 * @param {Object} config - Analytics configuration
 * @param {string} config.eventName - Type of event ('click' or 'viewport impression')
 * @param {string} config.clickID - Unique identifier for the event
 * @param {Object} config.container - Container information
 * @param {Object} config.click - Click information (for click events)
 * @param {Object} config.impression - Impression information (for impression events)
 */
export const fireAnalyticsEvent = (config) => {
  if (typeof window !== 'undefined' && window.digitalData) {
    // Initialize digitalData.event array if it doesn't exist
    if (!window.digitalData.event) {
      window.digitalData.event = [];
    }

    const thdAnalyticsEvent = {
      category: { primaryCategory: 'batch' },
      eventInfo: { eventName: config.eventName },
      clickID: config.clickID,
      container: {
        component: 'Lists',
        category: '',
        name: 'Lists',
        id: 'lists-component',
        position: '',
        categoryPosition: '',
        type: 'content',
        ...config.container
      }
    };

    // Add click or impression specific data
    if (config.click) {
      thdAnalyticsEvent.click = {
        component: 'Lists',
        type: 'content',
        category: '',
        ...config.click
      };
    }

    if (config.impression) {
      thdAnalyticsEvent.impression = {
        component: 'Lists',
        type: 'content',
        category: '',
        ...config.impression
      };
    }

    window.digitalData.event.push(thdAnalyticsEvent);
  }
};

/**
 * Tracks clicks on Create List button in null state
 */
export const trackCreateListClick = () => {
  fireAnalyticsEvent({
    eventName: 'click',
    clickID: 'ck-_-Lists-_-lists-component-_-CreateListButton-_-1-_-lists-null-state',
    click: {
      id: 'lists-null-state',
      name: 'CreateListButton',
      position: 1
    }
  });
};

/**
 * Tracks clicks on Learn More button in null state
 */
export const trackLearnMoreClick = () => {
  fireAnalyticsEvent({
    eventName: 'click',
    clickID: 'ck-_-Lists-_-lists-component-_-LearnMoreButton-_-1-_-lists-null-state',
    click: {
      id: 'lists-null-state',
      name: 'LearnMoreButton',
      position: 1
    }
  });
};
